module.exports = __webpack_public_path__ + "static/media/ExportIcon2.e44a6afc.svg";